import { Tab as FractalTab } from '@snowball-tech/fractal/dist/src/components/Tabs'

import snakeCase from 'lodash/fp/snakeCase'

import type { MediaTypes } from '../../../types'

import { AllowedMediaSources } from '../../../enums'
import useTranslations from '../../../hooks/useTranslations'

type Props = {
  name: AllowedMediaSources
  type: MediaTypes
}
export default function Tab({ name, type }: Props) {
  const $t = useTranslations()

  return (
    <FractalTab
      label={$t(`editor.${type}.loader.${snakeCase(name)}.tab`)}
      name={name}
    />
  )
}
